module.exports = "function rowRenderer ({ isScrolling, ...rest }) {\n  return isScrolling\n    ? <LightRow {...rest} />\n    : <FullRow {...rest} />\n}\n"


/*****************
 ** WEBPACK FOOTER
 ** ./~/raw-loader!./examples/is-scrolling-cell-renderer.js
 ** module id = 285
 ** module chunks = 0
 **/